export { default as RichText } from './RichText'
export type { RichTextProps } from './RichText'
